import { API_URL } from "config";
import Http from "util/https";
import { Item } from "../types/index";

async function getItem(id:string) {
  // const http = await Http.default.useCognitoAuth();
  const http = await Http.default;
  // ${parseInt(id,10)}でint型にしなくても動作する
  const url = `${API_URL}/item/${id}`;
  const res = await http.get<Item>(url);
  return res.data;
}
export default getItem;